<div class="one" fxLayout="column" [formGroup]="matterTrademarkForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.APPLICATIONNO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.APPLICATIONNO),
      }"
    >
      <mat-label>Application Number</mat-label>
      <input
        matInput
        formControlName="APPLICATIONNO"
        matTooltip="{{ toolTipList ? toolTipList.APPLICATIONNO?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.APPLICATIONNO) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.APPLICATIONNO.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.APPLICATIONNO?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  @if (this.action == 'edit' || this.action == 'duplicate') {
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.APPLICATIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.APPLICATIONDATE),
      }"
    >
      <mat-label>Application Date</mat-label>
      <input
        formControlName="APPLICATIONDATE"
        (dateChange)="CommanDatePickerEvent('change', $event)"
        matInput
        name="APPLICATIONDATE"
        [matDatepicker]="picker1"
        matTooltip="{{ toolTipList ? toolTipList.APPLICATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      @if (testBool && toolTipList.APPLICATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.APPLICATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.APPLICATIONDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  }

  @if (this.action == 'edit' || this.action == 'duplicate') {
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.JURISDICTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.JURISDICTION),
      }"
    >
      <mat-label>Jurisdiction</mat-label>
      <input
        matInput
        formControlName="JURISDICTION"
        matTooltip="{{ toolTipList ? toolTipList.JURISDICTION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        maxlength="100"
      />
      @if (testBool && toolTipList.JURISDICTION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.JURISDICTION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.JURISDICTION?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  }

  @if (this.action == 'edit' || this.action == 'duplicate') {
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TYPEOFTRADEMARK),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TYPEOFTRADEMARK),
      }"
    >
      <mat-label>Type of TradeMark</mat-label>
      <input
        matInput
        formControlName="TYPEOFTRADEMARK"
        matTooltip="{{ toolTipList ? toolTipList.TYPEOFTRADEMARK?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        maxlength="100"
      />
      @if (testBool && toolTipList.TYPEOFTRADEMARK) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TYPEOFTRADEMARK.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TYPEOFTRADEMARK?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  }

  @if (this.action == 'edit' || this.action == 'duplicate') {
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRADEMARKCLASSES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRADEMARKCLASSES),
      }"
    >
      <mat-label>TradeMark Class</mat-label>
      <input
        matInput
        formControlName="TRADEMARKCLASSES"
        matTooltip="{{ toolTipList ? toolTipList.TRADEMARKCLASSES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        maxlength="20"
      />
      @if (testBool && toolTipList.TRADEMARKCLASSES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TRADEMARKCLASSES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.TRADEMARKCLASSES?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  }
  <!-- </div> -->
</div>
